<style lang="scss">



@media screen and (min-width: 55rem) {
  .MembershipStoreIntroduction-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    margin-top: 5rem;
    .MembershipStoreIntroduction-content {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-content: center;
      .MembershipStoreIntroduction-left {
        width: 70%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .MembershipStoreIntroduction-left-title {
          background-image: url("/media/yintai/svg/intime365.svg");
          width: 9rem;
          height: 4rem;
          background-size: 100% 100%;
        }

        .MembershipStoreIntroduction-left-line {
          width: 2rem;
          height: 0.4rem;
          background-color: #e5004f;
          margin-bottom: 3rem;
          margin-top: 2rem;
        }

        .MembershipStoreIntroduction-left-text {
          width: 90%;
          font-size: 1.2rem;
          color: #7f7f7f;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
      }
      .MembershipStoreIntroduction-right {
        width: 30%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .MembershipStoreIntroduction-picture {
          margin-top: 2rem;
          width: 100%;
          height: 90%;
          background-image: url("/media/yintai/membershipstore-44.jpg");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
          box-shadow: -5px 3px 3px #d4d2d2;
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .MembershipStoreIntroduction-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-content: center;
    .MembershipStoreIntroduction-content {
      width: 80%;
      display: flex;
      flex-direction: column-reverse;
      align-content: center;
      .MembershipStoreIntroduction-left {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .MembershipStoreIntroduction-left-title {
          background-image: url("/media/yintai/svg/intime365.svg");
          width: 9rem;
          height: 4rem;
          background-size: 100% 100%;
        }

        .MembershipStoreIntroduction-left-line {
          width: 2rem;
          height: 0.4rem;
          background-color: #e5004f;
          margin-bottom: 3rem;
          margin-top: 1rem;
        }

        .MembershipStoreIntroduction-left-text {
          width: 100%;
          font-size: 1.2rem;
          color: #7f7f7f;
          font-family:  'PingFang SC','Microsoft YaHei';
        }
      }
      .MembershipStoreIntroduction-right {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .MembershipStoreIntroduction-picture {
          margin-top: 2rem;
          width: 100%;
          height: 25rem;
          box-shadow: -5px 3px 3px #d4d2d2;

          background-image: url("/media/yintai/membershipstore-44.jpg");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: cover;
        }
      }
    }
  }
}
</style>

<template>
  <div class="MembershipStoreIntroduction-container">
    <div class="MembershipStoreIntroduction-content">
      <div class="MembershipStoreIntroduction-left">
        <div class="MembershipStoreIntroduction-left-title"></div>
        <div class="MembershipStoreIntroduction-left-line"></div>
        <div class="MembershipStoreIntroduction-left-text">
          银泰云店，是银泰百货旗下的新零售项目，2021年双11前夕，包括衢州、海宁、上虞、诸暨等8家银泰云店更将集中扎堆开业。<br />
          至此，银泰百货小业态mini云店已经覆盖22个城市，辐射8个省会，总数超过50家。这也意味着，即便是三线以下城市的用户，也可以享受到专柜正品的服务体验。<br />
          云店内主要利用“云屏”的交互方式，通过银泰百货数字化平台，结合线下各种热门美妆、潮流服饰的试用，达到一站式购物体验。<br />
          截止目前，云店已经拓展了多种场景，其中开在校园里的云店，如今已经进入了浙江外国语大学、杭州师范大学、浙江大学城市学院等，将不定时推出针对校园场景和年轻消费者的专属优惠活动；另一些直接开进了银泰百货——这一类云店可以把品牌打包一起入驻，补全不同地区银泰百货之间品牌力的差距；<br />
          云店也开放了加盟，也有云店直接开进三四线城市的其他百货商店，首家落位诸暨青悦城，对于一些需求高端品牌入驻、但自身实力还不够的商店来说，这能带来品牌逼格的提升。<br />
          银泰云店最大的特点，在于专柜内，顾客、货、场都是经过数字化的，线上线下一体化的链路也是数字化的。这些数据经过沉淀，指导后期基于地理位置的精确选品，为消费者提供更好的服务。<br />
        </div>
      </div>

      <div class="MembershipStoreIntroduction-right">
        <div class="MembershipStoreIntroduction-picture"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MembershipStoreIntroduction",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
